import React, { useEffect, useRef, useState } from 'react'
import MDButton from 'components/MDButton';
import { getHeaderInfo } from 'api/routes';
import { addHeaderImage, updateHeaderInfo } from './../../api/routes';
import { Backdrop, CircularProgress, Modal } from '@mui/material';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';
import urltoFile from './../../components/urlToFile';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'fit-content',
};

export default function HeaderInfo() {
    const [data, setData] = useState();
    const [bigTitle, setBigTitle] = useState();
    const [smallTitle, setSmallTitle] = useState();
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const [isImageUpload, setIsImageUpload] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleOpenLoading = () => {
        setLoading(true);
    };
    const handleCloseLoading = () => {
        setLoading(false);
    };
    useEffect(() => {
        handleOpenLoading()
        handleClose()
        getHeaderInfo((isOk, data) => {
            if (!isOk){
                handleCloseLoading()
                return toast.error(data.message);
            }
            else {
                handleCloseLoading()
                return setData(data)
            }
        })
    }, [])

    const updateHeader = () => {
        const data = {
            bigTitle,
            smallTitle,
        }
        handleOpenLoading()
        handleClose()
        updateHeaderInfo(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message)

            else {
                if (sessionStorage.getItem('headerimage') !== null) {
                    urltoFile(sessionStorage.getItem('headerimage'), 'file.jpeg', 'image/jpeg')
                        .then(function (file) {
                            const formData = new FormData();
                            formData.append("headerImage", new File([file], "file.jpeg", { type: "text/json;charset=utf-8" }));
                            addHeaderImage(formData, (isOk, data) => {
                                if (!isOk) {
                                    handleCloseLoading()
                                    return toast.error(data.message);
                                }
                                else {
                                    sessionStorage.removeItem('headerimage');
                                    return window.location.reload();
                                }
                            })
                        })
                } else return window.location.reload();
            }
        })
    }
    const editInfo = () => {
        setBigTitle(data[0].bigTitle)
        setSmallTitle(data[0].smallTitle)

        handleOpen()
    }

    const file = useRef(null);


    const uploadImage = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 < 6) {
                const reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (event) => {
                    sessionStorage.setItem("headerimage", event.target.result);
                    setIsImageUpload(true)
                };
            } else toast.error("حجم فایل باید کمتر از 6 مگابایت باشد");
        }
    }

    return (
        <div style={{ padding: '1rem' }}>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>عنوان بزرگ : </p>
                <p>{data && data[0].bigTitle}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>عنوان کوچک : </p>
                <p>{data && data[0].smallTitle}</p>
            </section>
            <section style={{ display: 'flex', margin: '1rem 0', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold' }}>عکس : </p>
            </section>
            <p>{data && data[0].image && <img src={`data:image/jpeg;base64,${data[0].image}`} alt='doctor' style={{ width: '200px', height: '200px', objectFit: 'contain' }} />}</p>
            <MDButton onClick={editInfo} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                ویرایش
            </MDButton>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <MDInput multiline type="text" label="عنوان بزرگ هدر" value={bigTitle} onChange={(event) => setBigTitle(event.target.value)} fullWidth />
                    <MDInput type="text" value={smallTitle} onChange={(event) => setSmallTitle(event.target.value)} label="عنوان کوچک هدر" fullWidth sx={{ marginTop: '1rem' }} />
                    <input ref={file} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage} />
                    <div style={{ borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da', height: '56px' }} onClick={() => file?.current?.click()}>
                        <p style={{ color: '#00000099', fontSize: '1rem' }}>تصویر هدر</p>
                        {isImageUpload ? <p style={{ color: 'rgb(74 222 128)', fontSize: '1rem' }}>آپلود شد</p> : <p style={{ color: '#00000099', fontSize: '1rem' }}>آپلود کنید</p>}
                    </div>
                    <MDButton onClick={updateHeader} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                        تایید
                    </MDButton>
                </MDBox>
            </Modal>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
